document.addEventListener('input', function () {
    /*  - OK - ds le combobox de recherche, on change la valeur de aria-activedescendant lorsque l'on monte ou on descend avec les fleches **/
    var d = document.getElementById('SRCH_help_center');
    d.setAttribute('aria-activedescendant', 'cabouge');

    /* - OK - pour chaque li role option, on ajoute une class sr-only avec categorie réponse**/
    const optionElements = document.querySelectorAll('a[role="option"]');
    optionElements.forEach(function (a) {
        const div = document.createElement('div');
        div.className = 'sr-only';
        div.textContent = 'catégorie réponse';
        a.appendChild(div);
    });

    /* - OK - modifier le contenu de <div role="status" class="ei_sronly" id="ei_srch_help_msgstatus-id"></div> avec xx résultats dans questions/réponses, yy suggestions sont affichées **/
    const statusDiv = document.getElementById('ei_srch_help_msgstatus-id');
    if (statusDiv) {
        statusDiv.textContent =
            'xx résultats dans questions/réponses, yy suggestions sont affichées';
    }

    /* - OK ? - ajouter <p id="suggestions-info" aria-hidden="true">Les suggestions suivantes lancent la recherche, les autres conduisent directement aux pages mentionnées</p> **/
    const cabouge = document.querySelector('.autocomplete_search');
    if (cabouge) {
        const style = window.getComputedStyle(cabouge);

        if (style.display === 'block') {
            console.log('bam !!!');
            const paragraph = document.createElement('p');
            paragraph.textContent =
                'Les suggestions suivantes lancent la recherche, les autres conduisent directement aux pages mentionnées';

            paragraph.id = 'suggestions-info';
            paragraph.setAttribute('aria-hidden', 'true');
            document.getElementById('lstresult').after(paragraph);
            setTimeout(function () {}, 1000);
        }
    }
});
